const levelOptions = [
  { value: 943240000, displayValue: "40E" },
  { value: 943240001, displayValue: "40F" },
  { value: 943240002, displayValue: "40G" },
  { value: 943240003, displayValue: "40S" },
  { value: 943240004, displayValue: "41G" },
  { value: 943240005, displayValue: "42C" },
  { value: 943240006, displayValue: "42G" },
  { value: 943240007, displayValue: "42S" },
  { value: 943240008, displayValue: "42U" },
  { value: 943240009, displayValue: "45E" },
  { value: 943240010, displayValue: "45G" },
  { value: 943240011, displayValue: "45S" },
];

export default levelOptions;
